<aside [hidden]="hide || (compartilhadoService.esconderLoading && !hide)" class="load-interceptor" #loadInterceptor>
  <div class="o-center">
    <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
  </div>
</aside>